<template>
    <div class="image-section-wrapper">
      <a :href="url" target="_blank" v-if="url != ''">
        <div class="image-section-container">
          <div class="image-container" >
            <img 
              :src="imageUrl" 
              :alt="alt" 
              class="background-image"
            >
            <img 
              :src="imageUrl" 
              :alt="alt" 
              class="background-image-phone"
            >
          </div>
        </div>
        <div class="text-content">
          <h2>{{ title }}</h2>
          <p>{{ content }}</p>
        </div>
        <div class="text-content-phone">
          <h2>{{ title }}</h2>
          <p>{{ content }}</p>
        </div>
      </a>
      <div v-else>
        <div class="image-section-container">
          <div class="image-container" >
            <img 
              :src="imageUrl" 
              :alt="alt" 
              class="background-image"
            >
            <img 
              :src="imageUrl" 
              :alt="alt" 
              class="background-image-phone"
            >
          </div>
        </div>
        <div class="text-content">
          <h2>{{ title }}</h2>
          <p>{{ content }}</p>
        </div>
        <div class="text-content-phone">
          <h2>{{ title }}</h2>
          <p>{{ content }}</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import BaseButton from '@/components/common/BaseButton.vue'
    import { useRouter } from 'vue-router'

    
    
    export default {
      name: 'ImageSection',
      components: {
        BaseButton
      },
      props: {
        imageUrl: {
          type: String,
          required: true
        },
        title: {
          type: String,
          required: true
        },
        content: {
          type: String,
          required: true
        },
        url: {
          type: String,
          required: true
        },
        alt:{
          type: String,
          required: true
        }
      },
      data() {
        return {
          router: useRouter()
        }
      },
      methods: {

      }
    }
    </script>
  
  <style scoped>
    .text-content-phone{
      display: none;
    }
    .text-content{
      display: block;
    }
  .image-section-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}

.image-section-container {
  width: 100%;

  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-color: #000;
}

.image-container {
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  overflow: hidden;
}

.background-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;
  display: block;
}

.text-content {
  position: absolute; /* 绝对定位 */
  top: 40%; /* 距离顶部20% */
  right: 15%; /* 距离右边10% */
  text-align: left; /* 文字右对齐 */
  color: #fff;
  padding: 0 20px;
  max-width: 40%; /* 限制文字区域的最大宽度 */
  margin-top: 10px;
}

.text-content h2 {
  color: #007bff;
  font-size: clamp(2rem, 3vw, 4rem);
}

.text-content p {
  font-size: clamp(1.5rem, 2vw, 2rem);
  margin: 0 auto;
  line-height: 1.5em;
}
.background-image-phone{
  display: none;
}
.background-image{
    display: block;
  }
@media screen and (max-width: 768px) {
  .img-s{
    margin-bottom: 0!important;
  }
  .text-content-phone{
      display: block;
      width: calc(100vw - 40px);
      margin-left: 20px;
      margin-right: 20px;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 30px;
      border-bottom: 1px solid #e4e4e4;
      margin-top: 15px;
    }
    .text-content-phone h2{
    color: #000;
    font-size: 20px;
    }
    .text-content-phone p{
      color: #6e6e73;
    }
    .text-content{
      display: none;
    }
  .image-section-container {
    flex-direction: column;
    background-color: transparent;
  }
  .image-container {
    width: 100%;
    aspect-ratio: 125/159
  }
  .text-content {
    position: static; /* 取消绝对定位 */
    text-align: left;
    color: #1d1d1f;
    margin-top: 15px;
    margin-left: 20px;
    margin-right: 20px;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 30px;
    border-bottom: 1px solid #e4e4e4;
  }

  .text-content h2 {
    font-size: clamp(1.3rem, 2vw, 1.5rem);
    color: #1d1d1f;
    /* font-weight: bold; */
  }

  .text-content p {
    font-size: clamp(1rem, 2vw, 1.5rem);
    color: #6e6e73;
  }
  .background-image{
    display: none;
  }
  .background-image-phone{
    display: block;
    width: 100%;
    position: relative;
    overflow: hidden;
    aspect-ratio: 125/159; /* 设置宽高比 */
  }
}
  </style>